export default __webpack_public_path__ + "static/media/biscuit.66fb21eb.png";